<template>
    <footer style="width:100%;">
        <div class="col-lg-12" v-if="!isMobile()">
            <div class="container">
                <div class="row">
                    <div class="col-lg-2 col-sm-12" v-for="footer in footersComputed" :value="footer.value" :key="footer.value">
                        <div  v-for="(title,key) in footer" :value="title.value" :key="title.value">
                            <h5 class="titulo">{{key}}</h5>
                            <ul class="list-unstyled text-small">
                                <li v-for="(item) in title" :value="item.value" :key="item.value">
                                    <a class="text-footer text-muted" :href="item.url">{{item.valor}}</a>
                                </li>
                            </ul>
                        </div> 
                    </div>
                     <div class="col-lg-4 col-sm-12"> 
                         <p class="titulo">Cliker</p>
                        <div v-for="items in cliker" :value="items.value" :key="items.value">
                            <p class="text-footer text-muted"> 
                                {{items.valor}}
                            </p>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12 " style="background: #1E2245;">
                <div class="container" v-if="isMobile()" id="footer">
                    <div class="col-lg-2 col-sm-12">
                        <h1 class="titulo text-center text-white">Contacto</h1>
                        <ul class="list-unstyled text-small d-flex space-between">
                            <li v-for="(contact) in contacto" :value="contact.value" :key="contact.value">
                                    <a class="text-footer text-white" :href="contact.url">{{contact.valor}}</a>
                                </li>
                        </ul>
                    </div>
                    <small class="d-block text-white text-copyright" style="margin-right:5%;margin-left:5%;">&copy; Copyright 2020 cliker Gestión de talento humano. <br>Todos los derechos reservados</small>
                    <div class="d-flex space-between mt-3" style="margin-right:auto;margin-left:auto;width:40%">
                        
                        <div class="social_btn_m mr-1">
                            <a href="" class="social_btn_">
                            <i class="" aria-hidden="true">
                                <img src="/static/images/icons/in.svg" alt="">
                            </i>
                        </a>
                        </div>
                        <div class="social_btn_m mr-1">
                            <a href="" class="social_btn_">
                            <i class="" aria-hidden="true">
                                <img src="/static/images/icons/fb.svg" alt="">
                            </i>
                        </a>
                        </div>
                        <div class="social_btn_m">
                            <a href="" class="social_btn_">
                            <i class="" aria-hidden="true">
                                <img src="/static/images/icons/inst.svg" alt="">
                            </i>
                        </a>
                        </div>
                    </div>
                </div>
                <div class="container" v-else id="footer"> 
                    <small class="float-left d-block text-white text-copyright">&copy; Copyright 2020 cliker Gestión de talento humano. Todos los derechos reservados</small>
                    <div class="float-right social-part">
                        <a href="" class="social_btn">
                            <i class="fa" aria-hidden="true">
                                <img src="/static/images/icons/fb-39.png" alt="">
                            </i>
                        </a>
                        <a href="" class="social_btn">
                            <i class="fa" aria-hidden="true">
                                <img src="/static/images/icons/inst-40.png" alt="">
                            </i>
                        </a>
                        <a href="" class="social_btn">
                            <i class="fa" aria-hidden="true">
                                <img src="/static/images/icons/in-42.png" alt="">
                            </i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import footerApi from "../api/footer";
import {mapState,mapActions} from 'vuex';

  export default {
      data() {
          return {
              footers:[],
              cliker:null,
              //contacto:null
          }
      },
      computed: {
          ...mapState("contact",["mail","tel1","tel2"]),
          ...mapState("footer",["charge"]),
          footersComputed(){
                this.footers.find(element => {
               if(element.Contacto){
                   element.Contacto.forEach(item =>{
                        if(item.valor.includes("@")){
                            item.url = "mailto:"+item.valor;
                        }else{
                            item.url = "tel:"+item.valor;
                        }
                   });

               }
            });
            return this.footers;
          },
          contacto(){
            let contact = null;
            this.footers.find(element => {
               if(element.Contacto){
                   element.Contacto.forEach(item =>{
                        if(item.valor.includes("@")){
                            item.url = "mailto:"+item.valor;
                        }else{
                            item.url = "tel:"+item.valor;
                        }
                   });

                   contact = element.Contacto;
               }
            });
             
            return contact;
          }
      },
      watch: {
          charge(bool) {
              if(bool){
                  this.getFooter();
              }
          }
      },
    methods: {
        ...mapActions("contact",["setContact"]),
        ...mapActions("footer",["chargeFooter"]),
        getFooter(){
            footerApi
            .getFooter()
            .then(response => {
                
                let footer = response.data;

                this.cliker = footer.shift();
                this.cliker = this.cliker.Cliker;
                this.footers = footer;
                this.setContact(this.contacto);
                this.chargeFooter(false);
            }).catch(err => {
                console.log("Ocurrio un error al cargar el footer.");
            });
        },
        isMobile: function() {
            var check = false;
            //console.log(window.screen.width);
            if(window.screen.width < 769){
                return check=true;
            }
        }
    },
    created() {
        this.getFooter();
    },
  }
</script>

<style scoped>
    .social-part .fa{
        padding-right: 20px;
    }

    .titulo {
        font-family: Muli-Extrabold;
        font-style: normal;
        font-size: 14px;
        line-height: 18px;
        align-items: center;
        text-align: justify;
        letter-spacing: 0.2px;

        color: #1E2245;
    }

    ul > li {
        text-align: left;
    }

    .text-footer {
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 9px;
        line-height: 18px;
        align-items: center;
        letter-spacing: 0.2px;

        color: #1E2245;
    }

    p.text-footer {
        text-align: justify !important;
    }

    .social_btn_m {
        width: 100%;
        padding:10px 10px 10px 10px;
        background:rgb(60, 101, 177,0.3);
        border-radius: 15.0978px;
    }
    .text-copyright{
        font-family: Muli;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 18px;
        /* identical to box height, or 200% */
        letter-spacing: 0.2px;

        color: #FFFFFF;
    }
    
</style>